import components from './components.json';
import common from './common.json';
import views from './views.json';
export default {
    components: components,
    common: common,
    views: views
};
